'use strict';

var AppState = require('app_state');
var i18n = require('utils/i18n');
var Notification = require('utils/notification');

var Lock = Marionette.Behavior.extend({
    events: {
        'click .js-deny': 'showInfo',
    },

    onRender: function () {
        this.checkButtonState();
    },

    onShow: function () {
        this.isInitialized = true;
        this.deviceID = this.getOption('getDeviceID')(this.view);

        var permissions = this.getOption('permissions');
        if (AppState.deviceIsLockedForUser(this.deviceID) && permissions) {
            var Permissions = require('models/permissions');

            // set all given permissions to read only
            var permList = {};
            _.each(permissions, function (p) {
                permList[p] = true;
            });

            this.view.setPermission(new Permissions.User(permList));
        }

        this.checkButtonState();
    },

    checkButtonState: function () {
        if (AppState.deviceIsLockedForUser(this.deviceID)) {
            this.changeButtons(this.getOption('buttons'));
        }
    },

    changeButtons: function (buttons) {
        if (typeof buttons === 'function') {
            buttons = buttons(this.view);
        }
        if (!buttons || buttons.length === 0) {
            return;
        }
        // disable all action-buttons and modify their style
        var self = this;
        _.each(buttons, function (btn) {
            btn = $(btn);
            if (btn.length === 1) {
                // filter out the classes used for javaScript interaction
                var curClass = _.filter(btn.attr('class').split(' '), function (cl) {
                    return !cl.startsWith('js-');
                });
                curClass = _.union(['js-deny'], curClass);

                // computed icon-color
                var rgb = btn.css('backgroundColor');
                rgb = rgb.substring(5, rgb.length - 1).split(',');
                var brightness = Math.min(parseInt(rgb[0]), parseInt(rgb[1]), parseInt(rgb[2]));

                // if background-color is white, or very bright, use black as color
                var style = 'locked';
                if (_.contains(curClass, 'btn-white') || brightness > 180 || parseFloat(rgb[3]) < 0.1) {
                    style += '-inverse';
                }

                btn.append('<span class="' + style + '"> <i class="fa fa-lock"></i></span>');
                btn.attr('class', curClass.join(' '));
            }
            if (btn.length > 1) {
                self.changeButtons(btn);
            }
        });

        $('.js-deny').off();
        $('.js-deny').on('click', this.showInfo);
    },

    showInfo: function (e) {
        e.stopImmediatePropagation();
        e.preventDefault();

        Notification.show(
            'warning',
            i18n.TR('Dieses Gerät wurde von einem anderen Nutzer gesperrt'),
            i18n.TR('Eine Bearbeitung ist erst nach der Entsperrung wieder möglich.'),
            5000
        );
    },
});

module.exports = Lock;
